import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";

const UserAchievements = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [achievementDate, setAchievementDate] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    if (!userId) {
      setErrorMessage("User not logged in. Please login first.");
      setIsLoading(false);
      return;
    }

    const newAchievement = {
      user: userId,
      trainer: null,
      title,
      description,
      achievement_date: achievementDate,
    };

    try {
      const response = await AxiosInstance.post(
        "companies/user/achievements/",
        newAchievement
      );

      if (response.status === 201 || response.status === 200) {
        console.log("Achievement added:", response.data);
        navigate(-1);
      } else {
        setErrorMessage("Failed to create achievement.");
      }
    } catch (error) {
      console.error("Error creating achievement:", error);
      setErrorMessage("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div
        className="modal d-block"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-md" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Add Achievement</h5>
            </div>

            <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
              {errorMessage && (
                <div className="alert alert-danger" role="alert">
                  {errorMessage}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="title" className="form-label">
                    Achievement Title <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="title"
                    className="form-control"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="description" className="form-label">
                    Description <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="description"
                    className="form-control"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="achievementDate" className="form-label">
                    Achievement Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="achievementDate"
                    className="form-control"
                    value={achievementDate}
                    onChange={(e) => setAchievementDate(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={isLoading}>
                    {isLoading ? "Saving..." : "Save Achievement"}
                  </button>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default UserAchievements;
